import { useEffect, useState } from "react";
import Navbar from "../Navbar.jsx";
import Footer from "../Foooter.jsx";
import FooterMovil from "../FooterMovil.jsx";
import EmailPrefs from "../EmailPrefs.jsx";
import api from "../../utils/apiClient";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate, Link } from "react-router-dom";
import "../../style/Stock.css";
import "../../style/Ajustes.css";

// Account settings hub: who you are + which emails you receive. Email
// preferences are enforced server-side; this is just where users manage them.
function Ajustes() {
  const { authToken } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
      return;
    }
    let cancelled = false;
    api
      .get("usuario/getbyToken")
      .then((res) => { if (!cancelled) setUser(res.data); })
      .catch((err) => console.error("Error fetching user:", err));
    return () => { cancelled = true; };
  }, [authToken, navigate]);

  return (
    <>
      <Navbar />
      <div className="search-bar">
        <div className="ajustes-head">
          <Link to="/mycars" className="ajustes-back">← Volver al perfil</Link>
          <h1>Ajustes</h1>
          <p>Tu cuenta y los correos que quieres recibir.</p>
        </div>
      </div>

      <div className="stock-view">
        <div className="ajustes-body">
          <section className="ajustes-card">
            <p className="ajustes-card-title">Mi cuenta</p>
            {user ? (
              <div className="ajustes-account">
                <div className="ajustes-field">
                  <span className="ajustes-label">Nombre</span>
                  <span className="ajustes-value">{user.nombre}</span>
                </div>
                <div className="ajustes-field">
                  <span className="ajustes-label">Correo</span>
                  <span className="ajustes-value">{user.correo}</span>
                </div>
                <div className="ajustes-field">
                  <span className="ajustes-label">Teléfono</span>
                  <span className="ajustes-value">{user.telefono}</span>
                </div>
                <div className="ajustes-field">
                  <span className="ajustes-label">Verificación</span>
                  <span className={"ajustes-chip " + (user.verficado ? "ok" : "pending")}>
                    {user.verficado ? "Verificado" : "Sin verificar"}
                  </span>
                </div>
              </div>
            ) : (
              <p className="ajustes-loading">Cargando…</p>
            )}
          </section>

          <EmailPrefs />
        </div>
      </div>

      <div className="footer">
        <Footer />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default Ajustes;
